import React from 'react';
import { Input } from '@heroui/react';
import { SearchDropdown } from '@/components/table';
import type { BlockedUsersSearchFields } from '@/hooks/blockedUsers';

interface SearchFieldsProps {
  searchFields: BlockedUsersSearchFields;
  setSearchFields: React.Dispatch<React.SetStateAction<BlockedUsersSearchFields>>;
  isSearchOpen: boolean;
  setIsSearchOpen: (open: boolean) => void;
  onApply: () => void;
  onClear: () => void;
}

export function SearchFieldsComponent({
  searchFields,
  setSearchFields,
  isSearchOpen,
  setIsSearchOpen,
  onApply,
  onClear
}: SearchFieldsProps) {
  return (
    <SearchDropdown
      isOpen={isSearchOpen}
      setIsOpen={setIsSearchOpen}
      widthPx={200}
      onApply={onApply}
      onClear={onClear}
    >
      <Input
        label="Search (Fingerprint/IP)"
        size="sm"
        value={searchFields.search}
        onValueChange={(v) => setSearchFields((s) => ({ ...s, search: v }))}
      />
      <Input
        label="Domain ID"
        size="sm"
        type="number"
        placeholder="Optional"
        value={searchFields.domain_id}
        onValueChange={(v) => setSearchFields((s) => ({ ...s, domain_id: v }))}
      />
    </SearchDropdown>
  );
}
